module.exports = __webpack_public_path__ + "img/os.aa12aecc.svg";